import React, { useMemo, useEffect } from "react";
import { Navigate, Route, Routes  } from "react-router-dom";
import { useGroupChatContext } from "./context/groupchatContext";
import { updateAxiosAuth } from "./helpers/setupAxios";
import GroupChat from "./pages/groupChat";
import Login from "./pages/login"
import ProviderLandingPage from "./pages/provider";
import GuestVezoRequest from "./pages/guest/GuestVezoRequest";
import ForgetPassword from "./pages/login/forgetPassword";
import ResetPassword from "./pages/login/resetPassword";

export function AppRoutes() {
    
    const groupChatContext = useGroupChatContext();

    const {authData, setAuthData} = useMemo(() => ({
        authData: groupChatContext.authData,
        setAuthData: groupChatContext.setAuthData
    }));

    // Keep the module-level auth refs in sync. The interceptors are
    // registered once at module load (setupAxios.js) so they are always
    // present before the first axios request fires. We only need to
    // refresh the auth data they read from whenever it changes.
    useEffect(() => {
        updateAxiosAuth(authData, setAuthData);
    }, [authData, setAuthData]);
    return (
        <Routes>
            <Route path="/guest/vezo" element={<GuestVezoRequest />} />
            <Route path="auth/reset-password/:token" element={<ResetPassword />} />
            <Route path="/provider" element={<ProviderLandingPage />} />
            {!authData?.auth ? (
                <Route>
                    <Route path="auth/login" element={<Login />} />
                    <Route path="auth/forgot-password" element={<ForgetPassword />} />
                    <Route path="auth" element={<Navigate from="/auth" exact={true} to="/auth/login" />} />
                    <Route path="" element={<Navigate from="/" exact={true} to="/auth/login" />} />
                </Route>
            ) : (
                <Route>
                    <Route path="/" element={<GroupChat />} />
                    <Route path="auth/login" element={<Navigate from="/auth/login" exact={true} to="/" />} />
                </Route>
            )}
        </Routes>
    );
}
